import {
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Link as MuiLink,
} from '@mui/material'
import { useRootLoaderData } from 'components/Root.loader'
import { AUTHORITIES_JP } from 'config'
import { useAlert } from 'hooks/useDialog'
import { useState, useMemo } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { timeFormat } from 'utils/format'

import { useLoaderData } from './UsersConfig.loader'
import UsersSearch from './UsersSearch'

export default function UserList() {
  const navigate = useNavigate()
  const rootData = useRootLoaderData()
  const { maximumCount } = rootData.userGroupConfig
  const usersGroups = useLoaderData()
  const alert = useAlert()
  const [search, setSearch] = useState('')
  const users = useMemo(
    () =>
      search
        ? usersGroups.users.filter((x) => x.name.includes(search) || x.email.includes(search))
        : usersGroups.users,
    [search, usersGroups],
  )

  const addUser = () => {
    if (usersGroups.users.length >= maximumCount) {
      return alert({
        message: [
          `登録できるユーザーは${maximumCount}人までです。`,
          '上限を超えて登録したい場合は、システム管理者までお知らせください',
        ],
      })
    }
    navigate('new')
  }

  return (
    <>
      <Box display="flex" justifyContent="space-between" marginBottom={2}>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={addUser}
            data-testid="add-users-button"
          >
            新規追加
          </Button>
          <Button
            variant="outlined"
            color="primary"
            component={Link}
            to="import"
            data-testid="bulk-add-users-button"
          >
            一括ユーザー追加
          </Button>
        </Box>
        <Box maxWidth="240px">
          <UsersSearch search={search} setSearch={setSearch} />
        </Box>
      </Box>
      <UsersTable users={users} />
    </>
  )
}

function UsersTable({ users }) {
  return (
    <Table size="small" aria-label="a dense table">
      <TableHead data-testid="table-head-users">
        <TableRow sx={{ '& th': { backgroundColor: 'grey.200' } }}>
          <TableCell>名前</TableCell>
          <TableCell>ビジネスID</TableCell>
          <TableCell>権限</TableCell>
          <TableCell>最終ログイン時間</TableCell>
        </TableRow>
      </TableHead>
      <TableBody data-testid="table-body-users">
        {users.map((row) => (
          <TableRow key={row.userID}>
            <TableCell component="th" scope="row">
              <MuiLink color="inherit" underline="always" component={Link} to={String(row.userID)}>
                {row.name}
              </MuiLink>
            </TableCell>
            <TableCell>{row.email}</TableCell>
            <TableCell>{AUTHORITIES_JP[row.authority]}</TableCell>
            <TableCell>{row.updatedAt ? timeFormat(row.updatedAt) : '<未ログイン>'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
